import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getDatabase } from 'firebase/database';

// PulsePlay 2.0 Firebase configuration (project: pulseplaynew)
// Single-DB choice: Firestore is the source of truth for the live + durable
// session layer. (Realtime Database is intentionally not used.)
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Firestore (single source for live + durable session state)
export const database = getFirestore(app);

// Legacy only: Realtime Database export kept so the old space-game code
// (functions/spaceGameFirebase.js) still imports cleanly. NOT used by
// PulsePlay 2.0 — Firestore is the single source of truth.
export const realtimeDatabase = getDatabase(app);

export default app;
